import { render } from "./GmailInbox.vue?vue&type=template&id=2fdde7e0&scoped=true"
import script from "./GmailInbox.vue?vue&type=script&lang=js"
export * from "./GmailInbox.vue?vue&type=script&lang=js"

import "./GmailInbox.vue?vue&type=style&index=0&id=2fdde7e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdde7e0"]])

export default __exports__